export default __webpack_public_path__ + "static/media/20.f729d2ba.png";